import React, { Component } from "react";
import Header from "../Layout/Header/Header";
import Footer from "../Layout/Footer/Footer";
import Prize_winners from "./Prizes/Prize_winners";
import Poweredby_after from "./Powered-by/Poweredby_after";
import edition01 from "../../Assets/img/edition_01.svg";
import edition02 from "../../Assets/img/edition_02.svg";
import completed_editions from "../../Assets/img/completed_edition.png";


class Current_editions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
    };
  }

 

  render() {
    return (
      <div className="welcome innerBody">
        <Header />

          <div className="completed_editions container">

            <div className="row mt-5 mb-5 topsec">

              <div className="col-lg-5 col-md-12 col-12 mt-3">

                <h3 className="mb-3"> SUMMER EDITION'2.0 </h3>

                <h5 className="mb-3"> Time Spent: 2 Days, 18 Hours, 23 Minutes </h5>

                <p className="mb-3"> <span> Your Rank &nbsp; &nbsp; <b> 158 </b> out of 36 </span> </p>

                <p className="mb-3"> Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est </p>

                <button type="button" className="btn btn-yellow "> RESUME  </button> &nbsp; &nbsp;
                <button type="button" className="btn btn-yellow "> HALL OF FAME  </button>             
            
              </div>

              <div className="col-lg-7 col-md-12 col-12 pt-3 text-right">
                <img src={completed_editions} alt="" />
              </div>

            </div>   
          </div>

           <div className="container prize_winners">
          <h3 className="pb-3 text-center"> PRIZES </h3>
          <Prize_winners />
        </div>

          <div className="container-fluid bg-base mt-4">
            <div className="container">
              <div className="row">
                <div className="col pl-0 pr-0">
                  <div className="card card-body border-0 o-hidden mb-0 text-light">
                    <div className="position-relative flex-column flex-md-row align-items-center signup_now">
                      <div className="h3 text-center mb-md-0">
                        <span> <b> Bring your Friends to challenges.</b> </span>  Start inviting your friends and play together  &nbsp; &nbsp; &nbsp; 
                      <a href="/invite-friends" className="btn btn-lg btn-yellow ml-2 mt-2 mb-2 invite_btn">
                        INVITE NOW
                      </a>
                      </div>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        <div className="bg_dark"> <Poweredby_after /> </div>

       <div className="container">

          <div className="pt-5 pb-5 previous_editions">

           <div className="row pb-4"> 
            <div className="col-md-7">  
              <h3 className="text-right text-xs-center"> PREVIOUS EDITIONS </h3>
            </div>  

            <div className="col-md-5 text-right text-xs-center">
              <a href="/editions"> View All Editions > </a>
            </div>

            </div>

            <p className="pb-3 text-center"> Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est </p>

           <div className="row editions">

              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
               <div className="edition_bg">
                <h5> Summer Edition’20 </h5>
                <p> Completed on 4th July 2020 </p> 
                <img src={edition01} alt="" /> 

                <p> <br/> Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. </p>
                
                <div className="text-center"> <a href="/current-editions" className="btn btn-yellow mt-3"> HALL OF FAME </a> </div>
               </div>
              </div>


              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
               <div className="edition_bg">
                <h5> Summer Edition’20 </h5>
                <p> Completed on 4th July 2020 </p> 
                <img src={edition02} alt="" /> 

                <p> <br/> Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. </p>
                
                <div className="text-center"> <a href="/current-editions" className="btn btn-yellow mt-3"> HALL OF FAME </a> </div>
               </div>
              </div>


          

          </div>

         </div>

         </div>

        <Footer />
      </div>
    );
  }
}

export default Current_editions;
